import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
import Resize from 'vuetify/lib/directives/resize';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VSheet,
    { staticClass: "treemap" },
    [
      !_vm.loading
        ? _c("low-balance-alert", {
            attrs: { balanceService: _vm.startBalanceService },
            on: { clickedProduct: _vm.clickedLowBalanceProduct },
          })
        : _vm._e(),
      _c(VDivider, { staticClass: "my-4" }),
      _c("div", { staticClass: "text-subtitle-2 ma-2 text-center" }, [
        _vm._v(
          " " +
            _vm._s(_vm.$vuetify.lang.t("$vuetify.dashboard.inventoryBalance")) +
            " "
        ),
      ]),
      _c(
        "div",
        { staticClass: "d-flex justify-space-between" },
        [
          _c(
            VBtnToggle,
            {
              on: { change: _vm.changeRoot },
              model: {
                value: _vm.group,
                callback: function ($$v) {
                  _vm.group = $$v
                },
                expression: "group",
              },
            },
            _vm._l(_vm.rootProducts, function (node) {
              return _c(VBtn, { key: node.index }, [
                _vm._v(" " + _vm._s(node.name) + " "),
              ])
            }),
            1
          ),
          _c(
            "div",
            { staticClass: "my-auto" },
            [
              _vm.displayMode == "list"
                ? _c(
                    VBtn,
                    {
                      attrs: { icon: "", color: "primary" },
                      on: { click: _vm.toggleDisplayMode },
                    },
                    [_c(VIcon, [_vm._v("mdi-chart-tree")])],
                    1
                  )
                : _vm._e(),
              _vm.displayMode == "treechart"
                ? _c(
                    VBtn,
                    {
                      attrs: { icon: "", color: "primary" },
                      on: { click: _vm.toggleDisplayMode },
                    },
                    [_c(VIcon, [_vm._v("mdi-format-list-bulleted")])],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { border: "1px solid #ccc" } },
        [
          _vm.products && _vm.displayMode == "treechart"
            ? _c(
                VSlideGroup,
                {
                  attrs: { "show-arrows": "" },
                  model: {
                    value: _vm.subGroupIndex,
                    callback: function ($$v) {
                      _vm.subGroupIndex = $$v
                    },
                    expression: "subGroupIndex",
                  },
                },
                _vm._l(_vm.subGroups, function (subgroup) {
                  return _c(VSlideItem, {
                    key: subgroup.id,
                    staticClass: "ma-4",
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ active, toggle }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "d-flex",
                                  on: { click: toggle },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rounded-circle mr-3 my-auto",
                                      style: `backgroundColor: ${subgroup.color}; width: 18px; height: 18px;`,
                                    },
                                    [
                                      active
                                        ? _c(
                                            VIcon,
                                            {
                                              staticClass: "mb-2",
                                              attrs: { small: "" },
                                            },
                                            [_vm._v("mdi-check")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      class: `text-caption legend ${
                                        active ? "selected-legend" : ""
                                      }`,
                                    },
                                    [_vm._v(" " + _vm._s(subgroup.name) + " ")]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  })
                }),
                1
              )
            : _vm._e(),
          _vm.displayMode == "treechart"
            ? _c(
                "div",
                [
                  _c(
                    VSheet,
                    {
                      ref: "treemapContainer",
                      staticClass: "d-flex flex-column justify-center",
                      attrs: { elevation: 2 },
                    },
                    [
                      _vm.loading
                        ? _c(VSkeletonLoader, {
                            attrs: { type: "card-heading, image, image" },
                          })
                        : _vm._e(),
                      _c(
                        "div",
                        { staticStyle: { position: "relative" } },
                        [
                          _vm.products
                            ? _c("d3-treemap", {
                                directives: [
                                  {
                                    def: Resize,
                                    name: "resize",
                                    rawName: "v-resize",
                                    value: _vm.onResize,
                                    expression: "onResize",
                                  },
                                ],
                                key: _vm.ts,
                                attrs: {
                                  width: _vm.containerWidth,
                                  height: _vm.windowSize.y * 0.8,
                                  data: _vm.filteredProducts,
                                  nameFn: _vm.nameFn,
                                  valueFn: _vm.nodeValue,
                                  labelFn: _vm.labelFn,
                                  colorFn: _vm.colorFn,
                                  fontSize: 12,
                                },
                                on: {
                                  click: _vm.clickedTreeMap,
                                  drillDown: _vm.drillDownTreemap,
                                },
                              })
                            : _vm._e(),
                          _c(
                            VOverlay,
                            {
                              attrs: {
                                value: _vm.loadingBalance,
                                absolute: "",
                              },
                            },
                            [
                              _c(VProgressCircular, {
                                attrs: { indeterminate: "" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.displayMode == "list"
            ? _c(
                "div",
                [
                  _c(VTextField, {
                    staticClass: "ma-4",
                    attrs: {
                      "hide-details": "",
                      dense: "",
                      clearable: "",
                      outlined: "",
                      label: "Search Product",
                    },
                    model: {
                      value: _vm.searchTerm,
                      callback: function ($$v) {
                        _vm.searchTerm = $$v
                      },
                      expression: "searchTerm",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex",
                      staticStyle: { position: "relative" },
                    },
                    [
                      _c(VTreeview, {
                        class: _vm.isMobile ? "flex-grow-1" : "",
                        attrs: {
                          active: _vm.activeProducts,
                          search: _vm.searchTerm,
                          items: _vm.filteredProductsAsList,
                          "return-object": "",
                          activatable: "",
                          "selected-color": "primary",
                        },
                        on: {
                          "update:active": function ($event) {
                            _vm.activeProducts = $event
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "prepend",
                              fn: function ({ item }) {
                                return [
                                  item.children && item.children.length > 0
                                    ? _c(VIcon, [
                                        _vm._v("mdi-folder-outline"),
                                      ])
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          264133256
                        ),
                      }),
                      !_vm.isMobile
                        ? _c(VDivider, {
                            staticClass: "mx-2",
                            attrs: { vertical: "" },
                          })
                        : _vm._e(),
                      !_vm.isMobile
                        ? _c("div", { staticClass: "ma-4 flex-grow-1" }, [
                            _vm.activeProducts && _vm.activeProducts.length > 0
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      VScrollYTransition,
                                      { attrs: { mode: "out-in" } },
                                      [
                                        _vm.productNode
                                          ? _c("product-details", {
                                              key: _vm.productNode.id,
                                              attrs: {
                                                product: _vm.productNode,
                                              },
                                            })
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-caption font-weight-light",
                                  },
                                  [_vm._v(" No product selected ")]
                                ),
                          ])
                        : _vm._e(),
                      _c(
                        VOverlay,
                        { attrs: { value: _vm.loadingBalance, absolute: "" } },
                        [
                          _c(VProgressCircular, {
                            attrs: { indeterminate: "" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        VDialog,
        {
          staticStyle: { "z-index": "1000" },
          attrs: { fullscreen: _vm.$vuetify.breakpoint.xsOnly, scrollable: "" },
          model: {
            value: _vm.showDetails,
            callback: function ($$v) {
              _vm.showDetails = $$v
            },
            expression: "showDetails",
          },
        },
        [
          _vm.activeProducts && (_vm.displayMode == "treechart" || _vm.isMobile)
            ? _c(
                VSheet,
                {
                  staticClass: "text-center px-4",
                  staticStyle: { overflow: "scroll" },
                },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mt-6",
                      attrs: { text: "", color: "red" },
                      on: {
                        click: function ($event) {
                          _vm.showDetails = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$vuetify.lang.t("$vuetify.close")) +
                          " "
                      ),
                    ]
                  ),
                  _c(VDivider),
                  _vm.productNode
                    ? _c("product-details", {
                        key: _vm.productNode.id,
                        attrs: { product: _vm.productNode },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }